import {
  GUEST_TOTAL_PAID,
  GET_FILTERED_BEDS_COUNT,
  GET_SELECTED_OCCUPANCY_TYPE,
  GET_ARCHIVED_GUESTS,
  RECENT_TRANSACTION,
  CANCEL_CHECKOUT,
  MONTHLY_INCOME_BY_BUILDING,
  TODAYS_CHECKHOUT,
} from "../actionTypes/GuestActionTypes";

const initialState = {
  guestList: [],
  guest: {},
  totalAmountPaid: 0,
  loading: true,
  guestFilterCount: [],
  activeOccupancyType: "a",
  archievedGuests: [],
  cancelCheckout: {},
  currentMonthSum: 0,
  todaysCheckout: [],
};

export const GuestReducers = (state = initialState, action) => {
  switch (action.type) {
    case GUEST_TOTAL_PAID:
      return { ...state, totalAmountPaid: action.payload };

    case GET_ARCHIVED_GUESTS:
      const d = [...state.archievedGuests, ...action.payload];
      return {
        ...state,
        archievedGuests: d,
      };
    case RECENT_TRANSACTION:
      return { ...state, loading: false, guestList: action.payload };
    case GET_FILTERED_BEDS_COUNT:
      return { ...state, guestFilterCount: action.payload };
    case GET_SELECTED_OCCUPANCY_TYPE:
      return { ...state, activeOccupancyType: action.payload };
    case TODAYS_CHECKHOUT:
      return { ...state, todaysCheckout: action.payload };

    case MONTHLY_INCOME_BY_BUILDING:
      return { ...state, currentMonthSum: action.payload };
    default:
      return state;
  }
};
